import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { MapPin, Ruler, Layers } from 'lucide-react';

const Projects = () => {
  const { t } = useLanguage();

  return (
    <section id="projects" className="py-24 bg-[#1e293b]">
      <div className="container mx-auto px-8">
        <div className="text-center mb-16">
          <h2 className="heading-2 text-[#60a5fa] mb-4">{t.projects.title}</h2>
          <p className="body-large text-[#94a3b8] max-w-3xl mx-auto">
            {t.projects.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {t.projects.items.map((project, index) => (
            <div
              key={index}
              className="bg-[#0f172a] border border-[#1e40af] overflow-hidden hover:border-[#60a5fa] transition-all duration-300 group"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0f172a] to-transparent opacity-60"></div>
              </div>
              <div className="p-6">
                <h3 className="heading-5 text-[#60a5fa] mb-3">{project.title}</h3>
                <div className="flex flex-col space-y-2 mb-4 text-[#94a3b8]">
                  <div className="flex items-center space-x-2">
                    <MapPin className="w-4 h-4" />
                    <span className="caption">{project.location}</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Ruler className="w-4 h-4" />
                    <span className="caption">{project.size}</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Layers className="w-4 h-4" />
                    <span className="caption">{project.type}</span>
                  </div>
                </div>
                <p className="body-small text-[#94a3b8]">{project.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
